import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const PhotoUpload = ({ photos, setPhotos, label = "Photos (optionnel — max 5)", hint = "Ajoutez des photos pour un devis plus précis." }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (photos.length + files.length > 5) { toast.error("Maximum 5 photos"); return; }
    setUploading(true);
    for (const file of files) {
      try {
        const reader = new FileReader();
        const base64 = await new Promise((resolve) => { reader.onload = () => resolve(reader.result); reader.readAsDataURL(file); });
        const { data } = await axios.post(`${API}/api/property/upload-photo`, { file_data: base64, file_name: file.name });
        if (data.success) setPhotos(prev => [...prev, { url: data.url, name: file.name }]);
      } catch { toast.error(`Erreur upload ${file.name}`); }
    }
    setUploading(false);
    e.target.value = "";
  };

  return (
    <div data-testid="photo-upload-section">
      <label className="text-[#1A1A1A]/60 text-xs uppercase tracking-wide block mb-2">{label}</label>
      <p className="text-[#1A1A1A]/40 text-xs mb-2">{hint}</p>
      <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={handleUpload}
        className="text-xs text-[#1A1A1A]/60" disabled={uploading || photos.length >= 5} data-testid="photo-upload-input" />
      {uploading && <p className="text-xs text-[#1A1A1A]/50 mt-1">Upload en cours...</p>}
      {photos.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {photos.map((p, i) => (
            <div key={i} className="relative w-16 h-16 border border-[#1A1A1A]/10 overflow-hidden">
              <img src={`${API}${p.url}`} alt={p.name} className="w-full h-full object-cover" />
              <button onClick={() => setPhotos(prev => prev.filter((_, idx) => idx !== i))}
                className="absolute top-0 right-0 bg-red-500 text-white text-[8px] w-4 h-4 flex items-center justify-center">x</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotoUpload;
